import { createRoutine } from "redux-saga-routines";

export const info = createRoutine("TEACHER/INFO");
export const students = createRoutine("TEACHER/STUDENTS");
export const loadOne = createRoutine("TEACHER/STUDENT_INFO");
export const allowTest = createRoutine("TEACHER/ALLOW_TEST");